export default __webpack_public_path__ + "static/media/motorsports-pitch.4e0b39e3.png";